import React from "react";
import { Card, EmptyState } from "@jsq/ds/core";
import { celebrationWrapper } from "./style_vanilla.css";

export const Celebration = () => {
  return (
    <Card className={celebrationWrapper} padding="md">
      <EmptyState
        illustration="celebration"
        title="All done!"
        description="You may close this tab"
        data-testid="illustration-celebration"
      />
    </Card>
  );
};
